// import {List, ListItem, Toolbar, Avatar} from '@mui/material';
// import style from '../../Tools/Style';
// import React from 'react';
// import {useStateValue} from '../../../contexto/store';
// import Cuenta from '../ItemsMenuIzquierda/Cuenta';
// import Dashboard from '../ItemsMenuIzquierda/Dashboard';
// import Notas from '../ItemsMenuIzquierda/Notas';
// import Clientes from '../ItemsMenuIzquierda/Clientes';
// import Presupuestos from '../ItemsMenuIzquierda/Presupuestos';
// import Cobranzas from '../ItemsMenuIzquierda/Cobranzas';
// import Tareas from '../ItemsMenuIzquierda/Tareas';
// import Marketing from '../ItemsMenuIzquierda/Marketing';
// import Configuracion from '../ItemsMenuIzquierda/Configuracion';

// export function MenuIzquierda({classes}) {
//   const [{sesionUsuario}] = useStateValue ();

//   return (
//     <div notranslate="true" className={classes.list}>
//       <List>
//         <Toolbar />
//         <ListItem>
//           <Avatar
//             style={style.avatarmenu}
//             src={sesionUsuario.usuario.imagenPerfil}
//           />
//         </ListItem>
//       </List>

//       <Cuenta classes={classes} sesionUsuario={sesionUsuario} />

//       <Dashboard classes={classes} sesionUsuario={sesionUsuario} />

//       <Notas classes={classes} sesionUsuario={sesionUsuario} />

//       <Clientes classes={classes} sesionUsuario={sesionUsuario} />

//       <Presupuestos classes={classes} sesionUsuario={sesionUsuario} />

//       <Cobranzas classes={classes} sesionUsuario={sesionUsuario} />

//       <Tareas classes={classes} sesionUsuario={sesionUsuario} />

//       <Marketing classes={classes} sesionUsuario={sesionUsuario} />

//       <Configuracion classes={classes} sesionUsuario={sesionUsuario} />

//     </div>
//   );
// }
// import {List, ListItem, Toolbar, Avatar} from '@mui/material';
// // Si 'style' es un objeto de estilos en línea estándar, puedes mantenerlo.
// // Si 'style' utiliza makeStyles o crea estilos de forma que no es compatible con MUI v5,
// // entonces también necesitará ser refactorizado para usar 'sx' o 'styled' components.
// import style from '../../Tools/Style';
// import React from 'react';
// import {useStateValue} from '../../../contexto/store';
// import Cuenta from '../ItemsMenuIzquierda/Cuenta';
// import Dashboard from '../ItemsMenuIzquierda/Dashboard';
// import Notas from '../ItemsMenuIzquierda/Notas';
// import Clientes from '../ItemsMenuIzquierda/Clientes';
// import Presupuestos from '../ItemsMenuIzquierda/Presupuestos';
// import Cobranzas from '../ItemsMenuIzquierda/Cobranzas';
// import Tareas from '../ItemsMenuIzquierda/Tareas';
// import Marketing from '../ItemsMenuIzquierda/Marketing';
// import Configuracion from '../ItemsMenuIzquierda/Configuracion';

// // Elimina la prop 'classes' del componente
// export function MenuIzquierda() { 
//   const [{sesionUsuario}] = useStateValue ();

//   return (
//     // Reemplazamos className={classes.list} con la prop sx
//     // El valor 'width: 250' se definía en la clase .list de useStyles en BarSesion.js
//     <div notranslate="true" sx={{ width: 250 }}> 
//       <List>
//         <Toolbar />
//         <ListItem>
//           <Avatar
//             // Si 'style.avatarmenu' es un objeto JS plano con CSS-in-JS,
//             // puedes pasarlo directamente a 'style'. Si usa theme.spacing
//             // o algo de makeStyles, necesitarás convertirlo a 'sx'.
//             // Por ahora, asumimos que 'style.avatarmenu' es compatible o simplemente CSS.
//             style={style.avatarmenu} 
//             src={sesionUsuario.usuario.imagenPerfil}
//           />
//         </ListItem>
//       </List>

//       {/* Aquí es CRUCIAL. Todos estos componentes hijos (Cuenta, Dashboard, etc.)
//           TAMBIÉN NECESITARÁN ser refactorizados para no usar la prop 'classes'.
//           Por ahora, la he removido de la llamada, pero si no se actualizan,
//           probablemente generarán errores. */}
//       <Cuenta sesionUsuario={sesionUsuario} />
//       <Dashboard sesionUsuario={sesionUsuario} />
//       <Notas sesionUsuario={sesionUsuario} />
//       <Clientes sesionUsuario={sesionUsuario} />
//       <Presupuestos sesionUsuario={sesionUsuario} />
//       <Cobranzas sesionUsuario={sesionUsuario} />
//       <Tareas sesionUsuario={sesionUsuario} />
//       <Marketing sesionUsuario={sesionUsuario} />
//       <Configuracion sesionUsuario={sesionUsuario} />
//     </div>
//   );
// }

import { Avatar, Box, Typography, Divider } from '@mui/material';
import React from 'react';
import { useStateValue } from '../../../contexto/store';
import Cuenta from '../ItemsMenuIzquierda/Cuenta';
import Dashboard from '../ItemsMenuIzquierda/Dashboard';
import Notas from '../ItemsMenuIzquierda/Notas';
import Clientes from '../ItemsMenuIzquierda/Clientes';
import Presupuestos from '../ItemsMenuIzquierda/Presupuestos';
import Cobranzas from '../ItemsMenuIzquierda/Cobranzas';
import Tareas from '../ItemsMenuIzquierda/Tareas';
import Marketing from '../ItemsMenuIzquierda/Marketing';
import Configuracion from '../ItemsMenuIzquierda/Configuracion';
//import Encuestas from './../ItemsMenuIzquierda/Encuestas';

export function MenuIzquierda() { 
  const [{ sesionUsuario }] = useStateValue();

  return (
    <Box 
      translate="no"
      sx={{
        width: 280,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fafafa',
      }}
    >
      {/* Header del menú */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          color: 'white',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        <Avatar
          src={sesionUsuario.usuario.imagenPerfil}
          sx={{
            width: 80,
            height: 80,
            mb: 2,
            border: '3px solid rgba(255,255,255,0.3)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          }}
        />
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontWeight: 600,
            textAlign: 'center',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
          }}
        >
          {sesionUsuario.usuario.nombrecompleto}
        </Typography>
      </Box>

      <Divider sx={{ borderColor: 'rgba(0,0,0,0.08)' }} />

      {/* Lista de navegación */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', py: 1 }}>
        <Cuenta sesionUsuario={sesionUsuario} />
        <Dashboard sesionUsuario={sesionUsuario} />
        <Notas sesionUsuario={sesionUsuario} />
        <Clientes sesionUsuario={sesionUsuario} />
        <Presupuestos sesionUsuario={sesionUsuario} />
        <Cobranzas sesionUsuario={sesionUsuario} />
        <Tareas sesionUsuario={sesionUsuario} />
        <Marketing sesionUsuario={sesionUsuario} />
        {/* <Encuestas sesionUsuario={sesionUsuario} />  */}
        <Configuracion sesionUsuario={sesionUsuario} />
      </Box>

      {/* Footer */}
      <Box
        sx={{
          p: 2,
          borderTop: '1px solid rgba(0,0,0,0.08)',
          backgroundColor: '#f5f5f5',
        }}
      >
      </Box>
    </Box>
  );
}